import {connect} from 'react-redux'
import AdNavigateBack from 'gui/pages/mainRouter/pages/ad/components/commons/adNavigateBack/AdNavigateBack';
import {cancelOrder} from 'data/redux/actions/ordersActions';
import {IProduct} from 'data/interfaces/products';

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearProductState: (product: IProduct) => dispatch(cancelOrder(product)),
  };
};

const AdNavigateBackContainer = connect(mapStateToProps, mapDispatchToProps)(AdNavigateBack as any);

export default AdNavigateBackContainer;
